import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FeatureFlagsModule } from '@freelancer/feature-flags';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { NavigationLoggedOutComponent } from './navigation-logged-out.component';

@NgModule({
  imports: [CommonModule, TrackingModule, UiModule, FeatureFlagsModule],
  declarations: [NavigationLoggedOutComponent],
  exports: [NavigationLoggedOutComponent],
})
export class NavigationLoggedOutModule {}
